// extracted by mini-css-extract-plugin
export default {"productGrid":"BY-z","centerLink":"CY-z","productSection":"DY-z","item":"EY-z","ctaButton":"FY-z"};